// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chevron-down-double"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16.5 7L12 11.5L7.5 7M16.5 13.5L12 18L7.5 13.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChevronDownDoubleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chevron-down-double',
    ref,
    icon: element,
  },
));

ChevronDownDoubleIcon.displayName = 'ChevronDownDoubleIcon';

export default ChevronDownDoubleIcon;
